import { render, staticRenderFns } from "./FileInfoModal.vue?vue&type=template&id=bdfd3aa4"
import script from "./FileInfoModal.vue?vue&type=script&lang=ts"
export * from "./FileInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./FileInfoModal.vue?vue&type=style&index=0&id=bdfd3aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports